import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { Field, NumericInput, TextOutput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { useSelector } from 'react-redux';
import { hasValue } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';

interface INfdReadingProps extends IWorksheetComponent {
  heading?: string;
  enterTestCounts?: boolean;
  readonly?: boolean;
}

const Component: React.FC<INfdReadingProps> = ({
  createWorksheetSelector,
  heading,
  enterTestCounts,
  readonly = false,
}) => {
  const moistureContentDisplayField = (
    <Field
      input={<TextOutput />}
      name="MoistureContent"
      label="Moisture Content (%)"
      /*       additionalMessagePaths={['MoistureContentMeasured']} */
    />
  );
  const moistureContentEntryField = (
    <Field
      input={<NumericInput />}
      name="MoistureContentMeasured"
      label="Moisture Content (%)"
      /*       additionalMessagePaths={['MoistureContent']} */
    />
  );
  const moistureDensityDisplayField = (
    <Field
      input={<TextOutput />}
      name="MoistureDensity"
      label="Moisture Density"
      /*       additionalMessagePaths={['MoistureDensityMeasured']} */
    />
  );
  const moistureDensityEntryField = (
    <Field
      input={<NumericInput />}
      name="MoistureDensityMeasured"
      label="Moisture Density"
      /*       additionalMessagePaths={['MoistureDensity']} */
    />
  );

  const hasMeasuredMoistureContent = useSelector(pipe(createWorksheetSelector!('MoistureContentMeasured'), hasValue));
  const hasMeasuredMoistureDensity = useSelector(pipe(createWorksheetSelector!('MoistureDensityMeasured'), hasValue));

  //indicates a problem. Make all editable to allow one to be erased.
  const hasMeasuredAll = hasMeasuredMoistureContent && hasMeasuredMoistureDensity;

  return (
    <ListFieldSection heading={heading}>
      {enterTestCounts && (
        <Field
          input={readonly ? <TextOutput /> : <NumericInput />}
          name="DensityTestCount"
          label="Test Density Count"
        />
      )}
      {enterTestCounts && (
        <Field
          input={readonly ? <TextOutput /> : <NumericInput />}
          name="MoistureTestCount"
          label="Test Moisture Count"
        />
      )}
      <Field input={readonly ? <TextOutput /> : <NumericInput />} name="WetDensity" label="Wet Density" />
      {/* Moisture Content and Moisture Density are a pair of fields that can have one calculated and one entered. */}
      {readonly ? (
        <>
          {/* First for read-only mode just show the values.*/}
          {moistureContentDisplayField}
          {moistureDensityDisplayField}
        </>
      ) : (
        <>
          {hasMeasuredAll ? (
            <>
              {/* Indicates an error in the data as _both_ fields have values.
                  allow both to be edited to fix the problem. */}
              {moistureContentEntryField}
              {moistureDensityEntryField}
            </>
          ) : (
            /*Normal editing, allow input only when the other field is not entered*/
            <>
              {hasMeasuredMoistureDensity ? moistureContentDisplayField : moistureContentEntryField}
              {hasMeasuredMoistureContent ? moistureDensityDisplayField : moistureDensityEntryField}
            </>
          )}
        </>
      )}
      <Field input={<TextOutput />} name="DryDensity" label="Dry Density" />
    </ListFieldSection>
  );
};

const NfdReading = withInjectedProps(Component);

export { NfdReading };
export default NfdReading;
